import { config } from "../../lib/config";

const BASE = config.serviceHost;

async function request<T>(path: string, init?: RequestInit): Promise<T> {
    const res = await fetch(`${BASE}${path}`, init);
    if (!res.ok) {
        throw new Error(`Request failed: ${res.status}`);
    }
    return res.json();
}

function adminHeaders(adminPassword: string): Record<string, string> {
    return { "X-Prototype-Admin": adminPassword };
}

// Temporary feature — uses raw fetch instead of ts-rest (see prototype.router.ts for rationale)
export interface PrototypeDTO {
    slug: string;
    name: string;
    createdAt: string;
    updatedAt: string;
}

export const prototypeApi = {
    adminLogin(password: string) {
        return request<{ success: boolean }>("/prototypes/admin/login", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ password }),
        });
    },

    list(adminPassword: string) {
        return request<{ data: PrototypeDTO[] }>("/prototypes", {
            headers: adminHeaders(adminPassword),
        });
    },

    create(adminPassword: string, data: { name: string; password: string; htmlFile: File }) {
        const form = new FormData();
        form.append("name", data.name);
        form.append("password", data.password);
        form.append("htmlFile", data.htmlFile);
        return request<PrototypeDTO>("/prototypes", {
            method: "POST",
            headers: adminHeaders(adminPassword),
            body: form,
        });
    },

    delete(adminPassword: string, slug: string) {
        return request<{ success: boolean }>(`/prototypes/${slug}`, {
            method: "DELETE",
            headers: adminHeaders(adminPassword),
        });
    },

    verifyAndGetHtml(slug: string, password: string) {
        return request<{ valid: boolean; html?: string }>(`/prototypes/${slug}/view`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ password }),
        });
    },
};
